import { AlertDialog, Button, Flex } from "@radix-ui/themes";
import { ReactNode } from "react";
import { useGetAgencyFirst } from "../../hooks/agencies/use-get-agency-first";
import { useGetOtherProfile } from "../../hooks/profile/use-get-other-profile";

interface Props {
  visible: boolean;
  typePayment: "user" | "agent" | null;
  info: { id: string; amount: string } | null;
  children: ReactNode;
  handleCloseModal: () => void;
  handleSubmit?: () => void;
}

export const ModalTransferToUser = ({
  visible,
  typePayment,
  children,
  info,
  handleCloseModal,
  handleSubmit,
}: Props) => {
  const { id, amount } = info ?? {};

  const { user, isLoading: isLoadingUser } = useGetOtherProfile(
    Number(id),
    typePayment === "user" && Boolean(id)
  );

  const { agency, isLoading: isLoadingAgency } = useGetAgencyFirst(
    { id: Number(id) },
    typePayment === "agent" && Boolean(id)
  );

  const isLoading = isLoadingUser || isLoadingAgency;
  const img = typePayment === "user" ? user?.imgUser : agency?.imgAgency;
  const name = typePayment === "user" ? user?.username : agency?.name;

  return (
    <AlertDialog.Root open={visible}>
      <AlertDialog.Trigger>{children}</AlertDialog.Trigger>

      <AlertDialog.Content maxWidth="450px">
        {/* <div>
          <AlertDialog.Title>Revoke access</AlertDialog.Title>
        </div> */}

        <AlertDialog.Description
          size="2"
          style={{
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            fontWeight: "bold",
          }}
        >
          {isLoading && <span>Loading...</span>}

          {!isLoading && (
            <>
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <img
                  src={
                    img ||
                    "https://storage.zurylive.com/logo/zury-logo.png"
                  }
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "25px",
                    objectFit: "cover",
                  }}
                />

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      lineHeight: "1.2",
                    }}
                  >
                    <span>{name}</span>

                    <span
                      style={{
                        fontWeight: "normal",
                      }}
                    >
                      ID: {id}
                    </span>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span
                  style={{
                    fontWeight: "normal",
                    fontSize: "0.85rem",
                    color: "gray",
                  }}
                >
                  Transfer Amount
                </span>

                <div
                  style={{
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 4,
                    }}
                  >
                    <img
                      style={{ height: "12px", width: "12px" }}
                      src={"/coin.png"}
                    />

                    <span style={{ color: "#f3b429" }}>{amount}</span>
                  </div>

                  <div>
                    {typePayment === "user" && (
                      <span
                        style={{
                          background: "#2196f3",
                          color: "#fff",
                          padding: "4px 8px",
                          borderRadius: "12px",
                        }}
                      >
                        User
                      </span>
                    )}

                    {typePayment === "agent" && (
                      <span
                        style={{
                          background: "#ff4081",
                          color: "#fff",
                          padding: "4px 8px",
                          borderRadius: "12px",
                        }}
                      >
                        Agent
                      </span>
                    )}

                    <span style={{ marginLeft: "5px" }}>Coins account</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </AlertDialog.Description>

        <div
          style={{
            marginTop: "20px",
            borderTop: "1px solid #e3e2e2",
          }}
        >
          <Flex gap="3" mt="3" justify="end">
            <AlertDialog.Cancel>
              <Button variant="soft" color="gray" onClick={handleCloseModal}>
                Cancel
              </Button>
            </AlertDialog.Cancel>

            <AlertDialog.Action>
              <Button variant="solid" color="blue" onClick={handleSubmit}>
                Ok
              </Button>
            </AlertDialog.Action>
          </Flex>
        </div>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};
